var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"align-top",attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('open-channel-wizard',{attrs:{"uuid":_vm.$attrs.oc_uuid}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }